import React from 'react';
import {
  Box,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CardWithBoxShadow from '../../common/components/CardWithBoxShadow';

interface Props {
  children: React.ReactNode;
}

export default function ResetPasswordCard({ children }: Props) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box display="flex" alignItems="center" className="outer-container with-nav">
      <Box maxWidth={800} width="100%" marginY={4}>
        <CardWithBoxShadow>
          <Box paddingY={isSmallScreen ? 3 : 4} paddingX={isSmallScreen ? 3 : 5}>
            <Box className="card-content">
              <Typography variant="h5" marginX={1} marginBottom={3}>
                Reset Password
              </Typography>
              {children}
            </Box>
          </Box>
        </CardWithBoxShadow>
        <Box display="flex" flexDirection="row" marginY={2} justifyContent="center">
          <Typography variant="caption">
              Still having Issues?&nbsp;
              <Link
                  href="https://support.trainheroic.com/hc/en-us/requests/new"
                  target="_blank"
                  rel="noopener noreferrer"
              >
                  Contact&nbsp;Support
              </Link>
              .
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}